import { useEffect, useState } from "react";
import { Icon } from "~/components/icon/icon";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "~/components/ui/tooltip";

const CLAMP_HINT_AUTO_DISMISS_MS = 4500;

/** Auto-show once after preset clamp, then hover-only. */
export const StartDateClampHint = ({
  visible,
  autoShowSignal,
  message,
}: {
  visible: boolean;
  autoShowSignal: number;
  message: string;
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!visible) {
      // collapses the tooltip when the control becomes hidden so it reopens closed; synchronizes to the external visible prop
      setOpen(false);
    }
  }, [visible]);

  useEffect(() => {
    if (!visible || autoShowSignal === 0) {
      return;
    }
    // auto-opens the hint when the parent fires autoShowSignal, paired with the auto-dismiss timeout in the same effect
    setOpen(true);
    const timer = window.setTimeout(() => {
      setOpen(false);
    }, CLAMP_HINT_AUTO_DISMISS_MS);
    return () => window.clearTimeout(timer);
  }, [visible, autoShowSignal]);

  if (!visible) {
    return null;
  }

  return (
    <Tooltip open={open} onOpenChange={setOpen}>
      <TooltipTrigger asChild>
        <button
          type="button"
          className="inline-flex text-secondary-400 hover:text-secondary-500"
          aria-label={message}
          data-testid="sales-date-range-start-clamped-tooltip"
        >
          <Icon name="info" size="small" />
        </button>
      </TooltipTrigger>
      {message ? (
        <TooltipContent
          side="top"
          className="z-[100] max-w-xs text-left text-sm shadow-tooltip"
        >
          {message}
        </TooltipContent>
      ) : null}
    </Tooltip>
  );
};
